import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import "../../MissionAndVission/MissioonSideCards/MissioonSideCards.css";
import "../../TravelArrangements/TravelArrangementsSideCards/TravelArrangementsSideCards.css";
import "../../EntertainmentTravel/EnterSideCards/EnterSideCards.css";
import Heading from "../../../utls/Heading";

const EnterSideCards = () => {
  return (
    <>
      <div className="container safetyCardContainer">
        <div className="safetyCardBox mb-lg-5 pb-lg-4 mt-5 ps-lg-5">
          <div className="col-lg-6 col-md-6 col-sm-12 mt-xxl-5">
            <Heading className="headings mt-3 enter-heading ps-md-0">
              <span>Your Efficient</span> Travel Logistics Partner
            </Heading>
            <p className="missionP-one">
              At Blueberry Travel, we specialize in providing tailored travel
              logistics for the entertainment industry, ensuring every aspect of
              your journey stays stress-free. From booking private charters to
              managing stays, ground transportation, and VIP services, we take
              care of all the details, so your only focus should be towards your
              creative vision.
            </p>
            <p className="missionP-two">
              Whether you're traveling to major cities or remote locations, we
              offer additional services like visa coordination and itinerary
              customization for your crew. With Blueberry Travel, you can trust
              us to handle the logistics while you bring your creativity to
              life.
            </p>
          </div>

          <div className="col-lg-6 col-md-6 col-sm-12 travelarrangementimg mt-4 mt-lg-0 d-md-flex justify-content-md-center ms-md-4">
            <LazyLoadImage
              src="https://blueberrywebsites.azureedge.net/bbt/images/enter1.png"
              alt=""
              className="safetyTravelimg mission-images"
              loading="lazy"
            />
          </div>
        </div>

        <div className="safetyCardBoxReverse mb-lg-5 pb-lg-4 pe-lg-5">
          <div className="col-lg-6 col-md-6 col-sm-12 mt-xxl-3">
            <Heading className="headings mt-3 enter-heading ps-md-0">
              <span> Exclusive VIP </span>
              <span className="text-dark" style={{ fontWeight: "bold" }}>
                &{" "}
              </span>
              Celebrity Travel Services
            </Heading>
            <p className="missionP-one">
              Blueberry Travel delivers elite, personalized travel experiences
              for VIPs and celebrities. ensuring a trouble-free journey from
              beginning to end. We manage everything from private jet bookings
              to speedy visa processing while prioritizing privacy, security,
              and luxury at every step.
            </p>
            <p className="missionP-two">
              <h5 className="fw-bold list-h5-head">Where we Nail:</h5>
              <ul class="features-list">
                <li>Private and Commercial Jet Travel</li>
                <li>Secure Venue and Meeting Space Transfers</li>
                <li>Fast-Track Visa and Immigration Services</li>
                <li>Personalized Itineraries and Special Requests</li>
                <li>
                  Expert Coordination with Top Airlines, Hotels, and Transport
                  Providers
                </li>
              </ul>
            </p>
          </div>

          <div className="col-lg-6 col-md-6 col-sm-12 mt-4 mt-lg-0 travelarrangementimg d-md-flex justify-content-md-center me-xxl-5">
            <LazyLoadImage
              src="https://blueberrywebsites.azureedge.net/bbt/images/enter2.png"
              alt=""
              className="safetyTravelimg safetyTravelimg2 mission-images"
              loading="lazy"
            />
          </div>
        </div>

        <div className="safetyCardBox mb-lg-5 pb-lg-4 ps-lg-5">
          <div className="col-lg-6 col-md-6 col-sm-12 mt-xxl-3">
            <Heading className="headings mt-3 enter-heading ps-md-0">
              <span>Budget-Friently</span>Travel Management
            </Heading>
            <p className="missionP-one">
              We understand the importance of efficient cost management for
              entertainment productions. So, here we bring our travel services
              for such creators! Our solutions provide real-time travel budget
              tracking, expense monitoring, and detailed reporting tools, giving
              you full control and transparency over your travel expenditures at
              all times.
            </p>
            <p className="missionP-two">
              <h5 className="fw-bold list-h5-head">Our Offerings:</h5>
              <ul class="offerings-list">
                <li>24/7 Access to Travel Budget Updates</li>
                <li>Streamlined Expense Reporting</li>
                <li>Customizable Budget Tracking for Every Production</li>
                <li>Complete Financial Visibility and Control</li>
              </ul>
            </p>
          </div>

          <div className="col-lg-6 col-md-6 col-sm-12 travelarrangementimg mt-4 mt-lg-0 d-md-flex justify-content-md-center ms-md-4">
            <LazyLoadImage
              src="https://blueberrywebsites.azureedge.net/bbt/images/enter3.png"
              alt=""
              className="safetyTravelimg mission-images"
              loading="lazy"
            />
          </div>
        </div>

        <div className="safetyCardBoxReverse ct-lastcard-mb mb-lg-5 pb-lg-5 pe-lg-5">
          <div className="col-lg-6 col-md-6 col-sm-12 mt-xxl-3">
            <Heading className="headings mt-3 enter-heading ps-md-0">
              <span>24/7</span> Expert Support for Your Travel Needs
            </Heading>
            <p className="missionP-one">
              At Blueberry Travel, we’re not just taking you from one point to
              another; we make sure your creative journey runs efficiently. With
              round-to-clock assistance, our team is always available to handle
              any travel fear—from last-minute changes to complex logistics. We
              think ahead and implement it quick, ensuring your focus shouldn’t
              be on other details.
            </p>
            <p className="missionP-two">
              <h5 className="fw-bold list-h5-head">Here Are Our Offerings:</h5>
              <ul class="offerings-list">
                <li>24/7 Dedicated Support to Keep Your Production on Track</li>
                <li>
                  Quick and Precise Solutions for Travel, Accommodation, and
                  Conveyance
                </li>
                <li>Stress-Free Management for Last-Minute Changes</li>
              </ul>
            </p>
          </div>

          <div className="col-lg-6 col-md-6 col-sm-12 mt-4 mt-lg-0 travelarrangementimg d-md-flex justify-content-md-center me-xxl-5">
            <LazyLoadImage
              src="https://blueberrywebsites.azureedge.net/bbt/images/enter4.png"
              alt=""
              className="safetyTravelimg safetyTravelimg2 mission-images"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default EnterSideCards;
